/**
 * Created by sswaminathan on 9/8/22
 * File: InputComponent
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

import { Body, Bold } from '@panwds/react-ui'
import { useContext, useEffect, useMemo, useState } from 'react'
import {
  APP_ID_LOGGING_SERVICE,
  APP_ID_PRISMA_ACCESS_EDITION,
  APP_ID_PRISMA_SAAS
} from '../../../../../common/constants/GlobalConstants'
import { APP_ID_TO_NAME } from '../../../../../common/constants/LabelConstants'
import AppContext from '../../../../../common/context/AppContext'
/**
 *   TODO: Brief what is this component/class do
 */
import {
  ALLOW_DISABLE_ADDONS,
  APP_ID_TO_INPUT_REQUIRED, QUANTITY_READONLY_ADDONS,
  SUBSCRIPTION_ACTION_EDIT,
  URL_VALIDATIONS, USER_ACTION_REQUIRED
} from '../../../constants/SubscriptionConstant'
import CheckBoxComponent from '../../../dataInput/CheckBoxComponent'
import TextBox from '../../../dataInput/TextBox'
import ValidationFetcher from '../../../validation/ValidationFetcher'
import CapacityCalculator from '../capacityCalculator/CapacityCalculator'
import Units from './Units'

const InputComponent = (props) => {
  const {
    product,
    allocation,
    existingInstance,
    textBoxHeader,
    appUserLabel,
    appTextBoxDesc,
    isBundleDisabled,
    isBundle,
    indexKey,
    ...rest } = props
  const { getAppName } = useContext(AppContext)
  const { selectedTreeNode, instancesKeyBy, licenseInfo } = rest
  const [allowDisable, setAllowDisable] = useState(false)
  const [checkBoxStatus, setCheckBoxStatus] = useState(true)

  useEffect(() => {
    if (isBundle) {
      setCheckBoxStatus(!isBundleDisabled)
    }
    if (allocation) {
      setCheckBoxStatus(true)
    }
  }, [allocation, isBundle, isBundleDisabled])


  /**
   * Returns the checkboxdesc ,label and units
   */
  const { checkBoxLabelDesc, label, labelDesc, units } = useMemo(() => {
    const checkBoxLabelDesc = APP_ID_TO_INPUT_REQUIRED[product.app_id] ? appUserLabel ?? '' : ''
    const label = indexKey !== 'products' ? getAppName(product.app_id, APP_ID_TO_NAME[product.app_id.toLowerCase()]) : rest.labelOverRide
    const labelDesc = URL_VALIDATIONS.includes(product.app_id) ? '' : textBoxHeader
    const validation = ValidationFetcher(product.app_id, product.license_type, rest)
    const getUnits = ((validation, product) => {
      if (appTextBoxDesc && validation?.included_quantity) {
        return appTextBoxDesc?.replace('$', validation.included_quantity) ?? ''
      }
      else if (appTextBoxDesc) {
        return appTextBoxDesc?.replace('$', product?.purchased_size) ?? ''
      }
      return ''
    })
    const units = getUnits(validation, product)
    return { checkBoxLabelDesc, label, labelDesc, units }
  }, [appTextBoxDesc, appUserLabel, getAppName, indexKey, product, rest, textBoxHeader])

  const { url, validationRules } = useMemo(() => {
    const { app_id, license_type } = product
    const instanceInfo = instancesKeyBy[selectedTreeNode?.id]
    let url = ''
    if (instanceInfo) {
      instanceInfo.forEach((each) => {
        if (each.app_id === APP_ID_PRISMA_SAAS) {
          url = each.url
        }
      })
    }
    const validationRules = ValidationFetcher(app_id, license_type, rest)
    //CapacityCalculator({ product, allocation: rest?.allocation, ...rest })
    if (rest.licenseAction === SUBSCRIPTION_ACTION_EDIT) {
      validationRules.max_quantity = product.purchased_size
    }
    else {
      validationRules.max_quantity = validationRules.max_quantity ?? product.purchased_size
    }
    if (app_id === APP_ID_LOGGING_SERVICE) {
      validationRules.min_quantity = validationRules.min_quantity ?? 1
    }
    if (url.length > 0) {
      validationRules.validation_required = false
    }
    return { url: url.split('.')[0]?.replace('http://', '')
      .replace('https://', ''), validationRules }
  }, [instancesKeyBy, product, rest, selectedTreeNode?.id])

  useEffect(() => {
    if (USER_ACTION_REQUIRED.has(product.app_id)) {
      const appInstance = licenseInfo && licenseInfo[product.app_id] ? licenseInfo[product.app_id] : false
      setAllowDisable(!appInstance)
    }
    else if (allocation || (!allocation && !ALLOW_DISABLE_ADDONS.has(product.app_id))) {
      setAllowDisable(false)
    }
    else if (!allocation && ALLOW_DISABLE_ADDONS.has(product.app_id)) {
      const paeInstance = licenseInfo[APP_ID_PRISMA_ACCESS_EDITION]
      setAllowDisable(!paeInstance || (paeInstance && paeInstance.entitlements?.find(each => each.app_id === product.app_id && !each.purchased_size > 0)))
    }
  }, [allocation, instancesKeyBy, licenseInfo, product.app_id, rest?.instances, selectedTreeNode?.id])

  const disableTextBox = useMemo(() => {
    if (allocation || QUANTITY_READONLY_ADDONS.has(product.app_id)) {
      const productInfo = licenseInfo[APP_ID_PRISMA_ACCESS_EDITION]?.entitlements?.find(each => each.app_id === product.app_id)
      return !(!productInfo && URL_VALIDATIONS.includes(product?.app_id))
    }
    if (rest.licenseAction === SUBSCRIPTION_ACTION_EDIT) {
      const productInfo = licenseInfo[APP_ID_PRISMA_ACCESS_EDITION]?.entitlements?.find(each => each.app_id === product.app_id)
      if (URL_VALIDATIONS.includes(productInfo?.app_id)) {
        return true
      }
      if (!allocation && ALLOW_DISABLE_ADDONS.has(productInfo?.app_id)) {
        return !checkBoxStatus
      }
    }
    if (!allocation && ALLOW_DISABLE_ADDONS.has(product.app_id)) {
      return !checkBoxStatus
    }
  }, [allocation, checkBoxStatus, licenseInfo, product.app_id, rest.licenseAction])

  return (<div className={`${isBundle ? 'tw-pl-4' : ''} tw-flex tw-flex-row tw-w-full`}>
    <CheckBoxComponent
      {...{
        app_id: product.app_id,
        allocation,
        allowDisable,
        checkBoxLabelDesc,
        setCheckBoxStatus,
        label,
        licenseInfo,
        product,
        ...rest }} />
    {APP_ID_TO_INPUT_REQUIRED[product.app_id] && <div className='tw-flex tw-flex-col tw-mb-2 tw-ml-2'>
      {labelDesc?.length > 0 && <Body size="sm"><Bold addClassName="tw-pl-2">{labelDesc}</Bold></Body>}
      <div className='tw-flex-1 tw-flex tw-flex-row tw-pl-2'>
        <TextBox
          placeHolder={''}
          regex={URL_VALIDATIONS.includes(product.app_id)}
          maxCapacity={product.purchased_size}
          defaultCapacity={URL_VALIDATIONS.includes(product.app_id) ? url :
            CapacityCalculator({ product, allocation, ...rest })}
          appId={product.app_id}
          cspAccount={product.support_account_id}
          validationRules={validationRules}
          name={product.formFieldName}
          disabled={disableTextBox}
          allocation={allocation}
          checkBoxStatus={checkBoxStatus}
          {...{ checkBoxLabelDesc, allocation, product, ...rest }} />
        <Units units={units}/>
        {URL_VALIDATIONS.includes(product.app_id) &&
        <Body size="md"
          addClassName='tw-pl-1 tw-pt-2'
          appearance="secondary">
          {rest.domainPostFix[product.app_id]}
        </Body>}
      </div>
    </div>}
  </div>)
}

InputComponent.propTypes = {}
export default InputComponent
